import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import NotAuthorizedImage from '../components/common/Images/notAuthorized.webp';
import { useNavigate } from 'react-router-dom';

const NotAuthorized: React.FC<any> = () => {
  const { t } = useTranslation('translation');
  const navigate = useNavigate();

  const handleLogout = async () => {
    await localStorage.clear();
    navigate('/login');
};

  return (
    <div className='h-screen w-screen items-center flex flex-col justify-center'>
        <Grid className='flex justify-center'><img src={NotAuthorizedImage} alt="not-found" className='w-[50%]'/></Grid>
        <Grid className='text-[4rem] text-[#807d7d]'>401</Grid>
        <Grid className='text-[1.5rem] text-[#9c9898]'>{t('pageNotAuthorized')}</Grid>
        <Grid className='text-[1rem] text-[#807e7e]'>{t('pageNotFoundDescription')}</Grid>
        <Grid className='underline underline-offset-1 text-[#807d7d] cursor-pointer' onClick={() => handleLogout()}>{t('goToLoginPage')}</Grid>
    </div>
  )
}

export default NotAuthorized;
